import type { UserInfo } from "./services/login";

function hasMenuAccess(
  currentUser: UserInfo | undefined,
  address: string,
): boolean {
  if (!currentUser) return false;
  if (currentUser.isSuper) return true;
  return currentUser.menus?.some((m) => m.address === address) ?? false;
}

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: UserInfo } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser?.isSuper ?? false,

    // 游戏管理权限
    gamesEdit: hasMenuAccess(currentUser, "/games_edit"),
    gamesDetail: hasMenuAccess(currentUser, "/games_detail"),
    gamesNewMerchant: hasMenuAccess(currentUser, "/games_newMerchant"),
    gamesStatus: hasMenuAccess(currentUser, "/games_status"),
    gamesBatchStatus: hasMenuAccess(currentUser, "/games_betchStauts"),
    gamesAdd: hasMenuAccess(currentUser, "/games_add"),
    gamesTypes: hasMenuAccess(currentUser, "/games_types"),
    gamesTypesAdd: hasMenuAccess(currentUser, "/games_types_add"),
    gamesTypesEdit: hasMenuAccess(currentUser, "/games_types_edit"),

    // 代理商报表权限
    agentReport: hasMenuAccess(currentUser, "/report/agent"),
    agentReportExport: hasMenuAccess(currentUser, "/report/agent_export"),
  };
}
